module.exports = __webpack_public_path__ + "img/boutique.af3d7dc3.jpg";